import { Component, OnInit } from "@angular/core";
import { MatDialogConfig, MatDialog } from "@angular/material/dialog";
import {
  FormBuilder,
  Validators,
  AbstractControl,
  FormControl,
  FormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDatepickerInputEvent } from "@angular/material/datepicker";
import { DatePipe } from "@angular/common";
import { CommonService } from "app/_services/common.service";
import { Button } from "protractor";
import { MatButtonModule } from "@angular/material/button";

@Component({
  selector: "app-box7-hybrid",
  templateUrl: "./box7-hybrid.component.html",
  styleUrls: ["./box7-hybrid.component.css"],
})
export class Box7HybridComponent implements OnInit {
  public isMisc;
  public yesBox7Form;
  public noBox7Form;
  public isBoxFormVisbileButton = true;
  public isSelfEmployed;

  selfEmployedBasicForm = this.formBuilder.group({
    incomeWorkSE1: ["", Validators.required],
    receive10992: ["", Validators.required],
    watchChild3: ["", Validators.required],
    grandChildren4: ["", Validators.required],
    drive5: ["", Validators.required],
  });

  public incomeWorkSE1;
  public receive1099;
  public watchChild3;
  public grandChildren4;
  public drive5;
  public ifselfEmployed;

  public inventory1;
  public expensesHigher2;
  public business3;
  public homeOffice4;
  public taxiDriver5;
  public isExpertise;

  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private commonService: CommonService,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {}

  miscForm() {
    this.isMisc = true;
  }

  box7FormYes() {
    this.yesBox7Form = true;
    this.noBox7Form = false;
    this.isBoxFormVisbileButton = false;
  }

  box7FormNo() {
    this.router.navigate(["/taxreturn-expertise"]);
  }

  selfEmployed() {
    this.isSelfEmployed = true;
  }

  onsubmit() {
    //1 is for YES AND 2 is for NO
    if (
      this.incomeWorkSE1 != null &&
      this.receive1099 != null &&
      this.watchChild3 != null &&
      this.grandChildren4 != null &&
      this.drive5 != null
    ) {
      if (
        this.incomeWorkSE1 == 1 ||
        this.receive1099 == 1 ||
        this.watchChild3 == 1 ||
        this.grandChildren4 == 1 ||
        this.drive5 == 1
      ) {
        this.ifselfEmployed = true;
      } else {
        alert("Sorry you are not eligible.Please try MyFreeTaxes.com");
        this.navigateMenu();
      }
    } else {
      alert("Please fill in all the details");
    }
  }

  submitSelfEmployed() {
    // 1 for YES AND 2 for NO
    this.inventory1;
    this.expensesHigher2;
    this.business3;
    this.homeOffice4;
    this.taxiDriver5;

    if (
      this.inventory1 != null &&
      this.expensesHigher2 != null &&
      this.business3 != null &&
      this.homeOffice4 != null &&
      this.taxiDriver5 != null
    ) {
      if (
        this.inventory1 == 2 &&
        this.expensesHigher2 == 2 &&
        this.business3 == 2 &&
        this.homeOffice4 == 2 &&
        this.taxiDriver5 == 2
      ) {
        this.router.navigate(["/taxreturn-expertise"]);
      } else {
        alert("Sorry you are not eligible.Please try MyFreeTaxes.com");
        this.navigateMenu();
        console.log("Yes to any for if self employed then");
      }
    } else {
      alert("Please fill all the details");
    }
  }

  navigateFromLogin() {
    let isLoggedIn = localStorage.getItem("isLoggedIn");

    if (isLoggedIn === "true") {
      this.router.navigate(["/user-history"]);
    } else {
      alert("No History Found, Please login");
      this.router.navigate(["/login"]);
    }
  }

  navigateMenu() {
    this.router.navigate(["/search1-screen"]);
    console.log("navigateMenu");
  }

  openModal() {
    const buttonModal = document.getElementById("openModalButton");
    console.log("buttonModal", buttonModal);
    buttonModal.click();
  }

  openModal1() {
    const buttonModal = document.getElementById("openModalButton1");
    console.log("buttonModal", buttonModal);
    buttonModal.click();
  }
}
